import React from 'react';
import Header from './Header';
import '../styles/DesignerPage.css';

function DesignerPage() {
	// Add a ref to adjust content positioning if needed
	React.useEffect(() => {
		// Force scroll to top when component mounts
		window.scrollTo(0, 0);
	}, []);

	// TODO: Adjust padding to match currently deployed copy and add margin between some text blocks
	// Note ' charactes and potentially - will likely cause a deployed copy on cloudflare to fail build, these will need to be escaped via a method like &Agpos

	return (
		<div className="designer-page">
			<Header />

			<div className="designer-content">
				<div className="designer-hero">
					<img src="../designer/img1.jpg" alt="Cody Sanderson" className="hero-image" />
					<h2 className="designer-name">CODY SANDERSON</h2>
				</div>

				<div className="designer-bio">
					<span>
						About the Founder<br />
						Cody Sanderson was born in Gallup, New Mexico, USA in 1964 and was raised in Window Rock, Arizona – the seat of government and capital of the Navajo Nation. Cody had a less than glamorous upbringing as many other natives living on the confines of a reservation do, but this hardscrabble life helped to develop the determination, perseverance and hard-working ambition that has attributed to Cody’s success where others have failed. Cody has gained world renowned recognition for his pieces due to his daring creativity and unique, distinctive style.
						Cody’s use of stars is ubiquitous in almost all of his designs. Stars are recognized in every country and continent and appears on countless flags. They symbolize the heavens, brightness and good fortune. Cody wants his brand and his pieces to convey and invoke the same positive energy to everyone who wears his jewelry or his apparel. When describing his brand with one adjective – FUN is the first thing that comes to mind! Cody wants everyone, young and old, male or female to enjoy his adornments and the craftsmanship, imagination and enthusiasm he brings to each and every work of art!
					</span>
					<h2 className="designer-name">Cody’s slogan is – Wear it Now! Wear it Well! Wear it Out!</h2>
					<div className="designer-image-container">
						<img src="../designer/img2.jpg" alt="Cody at work" className="hero-image" />
					</div>
					<h2 className="designer-name">Achievements Of Sanderson’s Silver Craft</h2>
					<span>
						Utilizing the fast-disappearing technique of hand-forging and integrating them with CAD and 3D printing, Cody is combining traditional methods with modern technology and bringing his designs to the 21st century! His simple ring design, for example, is shaped into a “square-circle” with an inverted V appearance. It speaks of volumes of Sanderson’s insight into the skeletal system and attempt to make the ring more comfortable for wearing.
						Regardless of how “aggressive” a piece may look, Cody spends hours cutting, bending, shaping and refining the piece to ensure prolonged wear-ability without causing any discomfort to the wearer or admirer. Since the brand’s inception in 2001, Cody has won numerous awards for his work including the 2005 SWAIA (Southwestern Association for Indian Arts) Fellowship Award and the 2008 “Best of Show” Award at the Heard Museum in Phoenix.
					</span>
					<video controls autoPlay muted loop>
						<source src="../designer/designer_video.mp4" type="video/mp4" />
						Your browser does not support the video tag.
					</video>
					<h2 className="designer-name">Transformation From Scrap Ingot To Stunning Work Of Art!</h2>
					<span>
						Melting - Annealing - Quenching - Rolling - Grinding - Annealing  (2nd time) - Bending - Shaping - Texturing - Annealing (3rd time) - Stamping - Repousse Stamping - Repairing - Soldering - Annealing
						(4th time)  - Quenching - Finish Grind - Hand Hammered Shaping - Annealing (5th time) - Quenching - Anticlastic Shaping - Fitting - Oxidation - Polishing - Finished
					</span>
					<span>
						<br />
						Ever since 1999, each of Cody’s handmade pieces from his bracelets to rings to earrings and more have been made using ancient and traditional time consuming methods. Due to these complicated steps and difficult processes to achieve the “Artistic Value” he was looking for, he would only produce a few pieces at a time. Cody’s attention to detail makes all of his pieces worthy of the title “World Class”!!!
					</span>
					<div className="designer-image-container">
						<img src="../designer/designer_combined.jpg" alt="Combined" className="hero-image" />
					</div>
					<img src="../designer/signature.jpg" alt="Combined" className="signature" />
				</div>
			</div>
		</div>
	);
}

export default DesignerPage;